import styled from "styled-components/macro";

export default styled.div`
position: unset;
  top: 0;
  z-index: 9;
  width: 100%;
`;
